import * as Yup from "yup";

export const schemaActivationCode = Yup.object().shape({
  code: Yup.string().min(6).max(6).required(),
  email: Yup.string().email().required(),
  state: Yup.string().required(),
  role: Yup.string().required(),
});
